import { PublicShippingPriceType } from '../enums/public-shipping-price-type';
import { DictionaryCountry } from '@web/shared/module/dictionary';
import { Nillable } from '@web/utils';
import { ShippingMethod } from '../../shared/models/shipping-method';

export class PublicCartShipping {
  public constructor(
    private readonly data: {
      priceType: PublicShippingPriceType;
      price: number;
      country: Nillable<DictionaryCountry>;
      method: Nillable<ShippingMethod>;
      quantity: number;
      unitPrice: number;
    },
  ) {}

  public get priceType(): PublicShippingPriceType {
    return this.data.priceType;
  }

  public get price(): number {
    return this.data.price;
  }

  public get country(): Nillable<DictionaryCountry> {
    return this.data.country;
  }

  public get method(): Nillable<ShippingMethod> {
    return this.data.method;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get unitPrice(): number {
    return this.data.unitPrice;
  }
}
